import { render, staticRenderFns } from "./paragraph-controls.vue?vue&type=template&id=15b514e0&"
import script from "./paragraph-controls.vue?vue&type=script&lang=js&"
export * from "./paragraph-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports